// 引入自定义公共函数
import myPubFunction from '@/common/function/myPubFunction.js'
module.exports = {
	// 开发模式启用调式模式(请求时会打印日志)
	debug: process.env.NODE_ENV !== 'production',
	// 主云函数名称
	functionName: "router",
	//首页路径
	index: {
		url: '/pages/index/homePage'
	},
	// 登录页面路径
	login: {
		url: '/pages/login/index/index'
	},
	// 404 Not Found 错误页面路径
	error: {
		url: '/pages/error/404/404'
	},
	// 日志风格
	logger: {
		colorArr: [
			"#0095f8",
			"#67C23A"
		]
	},
	/**
	 * app主题颜色
	 * vk.getVuex('$app.config.color.main')
	 * vk.getVuex('$app.config.color.secondary')
	 */
	color: {
		main: "#ff4444",
		secondary: "#555555"
	},
	// 需要检查是否登录的页面列表
	checkTokenPages: {
		/**
		 * 如果 mode = 0 则代表自动检测
		 * 如果 mode = 1 则代表list内的页面需要登录，不在list内的页面不需要登录
		 * 如果 mode = 2 则代表list内的页面不需要登录，不在list内的页面需要登录
		 * 注意1: list内是通配符表达式，非正则表达式
		 * 注意2: 需要使用 vk.navigateTo 代替 uni.navigateTo 进行页面跳转才会生效
		 */
		mode: 2,
		list: [
			"*/pages/classification/index",
			"*/pages/login/*",
			"*/pages/error/*",
			"*/pages/index/homePage",
			"*/pages/question-bank/index",
			"*/pages/news/*",
			"*/pages/teachers/*",
			"*/pages/search/search-result-list",
			"*/privacy"
		]
	},
	// 需要检查是否可以分享的页面列表(仅小程序有效)
	checkSharePages: {
		/**
		 * 如果 mode = 0 则不做处理
		 * 如果 mode = 1 则代表list内的页面可以被分享，不在list内的页面不可以被分享
		 * 如果 mode = 2 则代表list内的页面不可以被分享，不在list内的页面可以被分享
		 * 注意: list内是通配符表达式，非正则表达式
		 */
		mode: 0,
		// ['shareAppMessage', 'shareTimeline'],
		menus: ['shareAppMessage'],
		list: [
			"/pages/index/*",
			"/pages/goods/*"
		]
	},
	// 静态文件的资源URL地址
	staticUrl: {
		// Logo
		logo: '/static/logo.png',
	},
	// 自定义公共函数，myPubFunction内的函数可通过vk.myfn.xxx() 调用
	myfn: myPubFunction,
	// 第三方服务配置
	service: {
		// 密钥和签名信息 (由于签名的获取比较麻烦,建议初学者使用上传到unicloud的方案,上传到阿里云OSS是给有特殊需求的用户使用)
		// 相关文档 : https://help.aliyun.com/document_detail/31925.html?spm=a2c4g.11186623.6.1757.b7987d9czoFCVu
		aliyunOSS: {
			// 密钥和签名信息
			uploadData: {
				OSSAccessKeyId: "",
				policy: "",
				signature: "",
			},
			// oss上传地址
			action: "https://xxx.oss-cn-hangzhou.aliyuncs.com",
			// 根目录名称
			dirname: "test",
			// oss外网访问地址，也可以是阿里云cdn地址
			host: "https://xxx.xxx.com",
			// 上传时,是否按用户id进行分组储存
			groupUserId: true,
			// 是否默认上传到阿里云OSS
			isDefault: false
		}
	},
	// 自定义拦截器
	interceptor: {

		// login:function(obj){
		// 	let { vk, params, res } = obj;
		// 	//console.log("params:",params);
		// 	//console.log("res:",res);
		// 	if(!params.noAlert){
		// 		vk.alert(res.msg);
		// 	}
		// 	console.log("跳自己的登录页面");
		// 	// 上方代码可自己修改，写成你自己的逻辑处理。
		// },

		// fail:function(obj){
		// 	let { vk, params, res } = obj;
		// 	//console.log("params:",params);
		// 	//console.log("res:",res);
		// 	return false;// 返回false则取消框架内置fail的逻辑,返回true则会继续执行框架内置fail的逻辑
		// 	// 上方代码可自己修改，写成你自己的逻辑处理。
		// }

	},
	"h5": {
		"url": "https://uni-starter.dcloud.net.cn/", //	前端网页托管的域名
		// 在h5端全局悬浮引导用户下载app的功能 更多自定义要求在/common/openApp.js中修改
		"openApp": {
			//是否在h5页面显示 引导app下载
			"show": false,
			//点击悬浮下载栏后打开的网页链接
			"openUrl": '/#/pages/ucenter/invite/invite',
			//左侧显示的应用名称
			"appname": 'UceEdu',
			//应用的图标
			"logo": './static/logo.png',
		}
	},
	"mp": {
		"weixin": {
			//微信小程序原始id，微信小程序分享时
			"id": "gh_33446d7f7a26"
		}
	},
	//关于应用
	"about": {
		//应用名称
		"appName": "UceEdu",
		//应用logo
		"logo": "/static/logo.png",
		//公司名称
		"company": "蜗客工作室",
		//口号
		"slogan": "基于云端一体的知识付费解决方案",
		//政策协议
		"agreements": [{
				"title": "用户服务协议", //协议名称
				"url": "https://ask.dcloud.net.cn/protocol.html" //对应的网络链接
			},
			{
				"title": "隐私政策",
				"url": "https://ask.dcloud.net.cn/protocol.html"
			}
		],
		//应用的链接，用于分享到第三方平台和生成关于我们页的二维码
		"download": "https://m3w.cn/uniapp",
		//version
		"version": "1.0.0" //用于非app端显示，app端自动获取
	},
	"download": { //用于生成二合一下载页面
		"ios": "https://itunes.apple.com/cn/app/hello-uni-app/id1417078253?mt=8",
		"android": "https://vkceyugu.cdn.bspapp.com/VKCEYUGU-97fca9f2-41f6-449f-a35e-3f135d4c3875/6d754387-a6c3-48ed-8ad2-e8f39b40fc01.apk"
	},
	//用于打开应用市场评分界面
	"marketId": {
		"ios": "id1417078253",
		"android": "123456"
	}
}
